import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-mobile-request-booking-dialog',
  templateUrl: './mobile-request-booking-dialog.component.html',
  styleUrls: ['./mobile-request-booking-dialog.component.scss'],
})
export class MobileRequestBookingDialogComponent {
  public vessel: Vessel;

  constructor(private dialogRef: MatDialogRef<any>) {}

  exitDialogClick(): void {
    this.dialogRef.close(null);
  }
}
